const headerBg   = 'https://download4.qcplay.com/h5-images/active/tideng/recall/bg.png';
const officeBtn  = 'https://download4.qcplay.com/h5-images/active/tideng/recall/official.png';
const loginBtn   = 'https://download4.qcplay.com/h5-images/active/tideng/recall/login.png';
const downloadBtn= 'https://download4.qcplay.com/h5-images/active/tideng/recall/download.png';
const logoutBtn  = 'https://download4.qcplay.com/h5-images/active/tideng/recall/logout.png';
const accountBtn = 'https://download4.qcplay.com/h5-images/active/tideng/recall/switch.png';

const activeBtn  = 'https://download4.qcplay.com/h5-images/active/snail/recall/head/download.png';

export const headerConfig = {
    not_logged_in: {
        background_image: headerBg,
        style: '',
        title: '提灯与地下城',
        sub_title: '海灵主宰，龙拳破天！',
        style: ''
    },
    logged_in: {
        background_image: headerBg,
        main_title_color: '#EDF5FF',
        sub_title_color: '#EDF5FF',
        tips_color: '#5679d0',
        game_name: '提灯与地下城',
    },
    operation_btn: {
        office_website: {
            style: {
                top: '0.55rem',
                right: '2.1rem', width: '1.6266666666666667rem', height: '0.8133333333333334rem'
            },
            background_image: '',
            img: officeBtn,
            link: 'https://tideng.qingcigame.com/leading/'
        },
        login: {
            background_image: '',
            img: loginBtn,
            style: {
                top: '0.55rem', width: '1.6266666666666667rem', height: '0.8133333333333334rem'
            },
        },
        change_account: {
            style: {
                top: '0.55rem', width: '1.6266666666666667rem', height: '0.8133333333333334rem'
            },
            background_image: '',
            img: accountBtn,
        },
        join_active: {
            width: '',
            height: '',
            background_image: '',
            img: activeBtn,
            style: '',
            link: ''
        },
        logout: {
            style: {
                top: '0.55rem', width: '1.6266666666666667rem', height: '0.8133333333333334rem'
            },
            background_image: '',
            img: logoutBtn,
        },
        download: {
            top: '0.2rem',
            width: '',
            height: '',
            img: downloadBtn,
            style: '',
            link: ''
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/tideng/recall/headerConfig.js